import css from './valuePane.module.scss';

import { memo } from 'react';

import useLocalStorageState from 'core/hooks/browser/useLocalStorageState';
import { SHOW_TRANSCRIPTION, SHOW_TRANSCRIPTION_DEFAULT } from 'core/options';

const Transcription = ({ transcription }: { transcription: string | null }) => {
  const [showTranscription, setShowTranscription] = useLocalStorageState(
    SHOW_TRANSCRIPTION,
    SHOW_TRANSCRIPTION_DEFAULT
  );

  if (!transcription) return null;

  const button = (
    <button
      title="Show / hide transcription"
      className={css.transcriptionToggler}
      onClick={() => setShowTranscription(v => !v)}
    >
      tʂ
    </button>
  );

  if (showTranscription) {
    return (
      <>
        <div key="tn" className={css.transcription}>
          {transcription}
        </div>
        {button}
      </>
    );
  }

  return button;
};

export default memo(Transcription);
